import SearchView from "./SearchView";
export default SearchView;